<main class="max-h-screen snap-y snap-mandatory overflow-y-scroll">
  <section class="snap-start h-screen relative text-slate-50" id="home">
    <video autoplay loop muted preload="auto" class="w-full h-full absolute z-0 object-cover">
      <source src="assets/video/Waves-with-filter.webm" type="video/webm" />
    </video>
    <div class="relative z-10 h-full flex items-stretch justify-center p-4 pb-0 md:justify-end md:pr-20">
      <div
        class="border border-b-0 border-white/50 rounded-t-lg p-6 md:p-8 max-w-md md:max-w-lg w-full md:w-auto h-[80%] self-end flex flex-col justify-between">
        <div class="flex-grow flex flex-col justify-center">
          <h1 class="text-center text-xl md:text-2xl xl:text-3xl font-light mb-6 md:mb-8">
            Smart Cloud Insights
          </h1>

          <div class="flex justify-center mb-6 md:mb-8">
            <img src="/assets/images/blueocean_logo_large.png" alt="logo" class="w-full" />
          </div>
        </div>

        <div class="flex justify-center pb-4">
          <button (click)="navigateWithFragment('what')"
            class="animate-bounce duration-100 flex items-center text-lg md:text-xl hover:text-blue-300 transition-colors">
            Discover More
            <span class="material-symbols-outlined text-slate-50 ml-2">
              keyboard_arrow_down
            </span>
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="snap-start h-screen text-slate-50 relative" id="what">
    <div class="mx-4 mt-4 flex gap-8 h-full">
      <div class="flex-col flex-grow w-3/5 p-8 m-auto px-8 justify-center items-center">
        <div class="text-lg xl:text-3xl leading-5 xl:leading-6">
          <h1 class="text-2xl">
            Automated cloud assessment insights provide you control over your
            cloud environment.
          </h1>
        </div>
        <div class="pt-4 text-sm text-slate-400 xl:text-base leading-5 xl:leading-6 tracking-normal">
          Blue Ocean is a SaaS Cloud Insights platform designed to assist you in
          gathering essential insights into your Azure cloud environment. This
          product is created by Cegeka and is the accumulation of proven cloud
          expertise, brought to you by multiple visualization dashboards.
        </div>
      </div>
      <div class="flex-col w-full m-auto px-8 justify-center items-center hidden md:flex">
        <div class="">
          <img src="/assets/images/discover_img01.png" alt="cloud" class="w-full" />
        </div>
      </div>
    </div>
    <div class="absolute bottom-4 text-center w-full">
      <button type="button" (click)="navigateWithFragment('why')">
        <span class="material-symbols-outlined">keyboard_arrow_down</span>
      </button>
    </div>
  </section>
  <section class="snap-start h-screen text-slate-50 relative flex items-center justify-center" id="why">
    <div class="mx-4 mt-4 flex gap-8">
      <div class="flex-col w-full m-auto px-8 justify-center items-center">
        <div class="text-2xl xl:text-4xl mb-2 xl:mb-4">
          <h1>Why Blue Ocean?</h1>
        </div>
        <div class="text-xl">
          <h3 class="my-2 xl:my-4">Central View</h3>
          <p class="mb-2 xl:mb-4 text-slate-400 text-sm xl:text-base leading-5 xl:leading-6 tracking-normal">
            Each dashboard provides a central view on a specific cloud category
            such as Cost and Compliancy. Multiple data sources are intertwined
            in order to provide a full view for that category without the need
            for checking multiple dashboards that provide a part of the required
            view.
          </p>
          <p class="mb-2 xl:mb-4 text-slate-400 text-sm xl:text-base leading-5 xl:leading-6 tracking-normal">
            By choosing the visualization of Cegeka insights through the Blue
            Ocean platform, you are adopting a best-practice, standard approach
            to assessing Azure environments. ensures that your cloud
            environment is not only efficient but also secure and compliant,
            ultimately supporting the success of your Azure projects.
          </p>
        </div>
      </div>
      <div class="flex-col w-3/5 h-full m-auto px-8 justify-center items-center hidden md:flex">
        <div class="aspect-square">
          <img src="/assets/images/discover_img02.png" alt="cloud" class="w-full" />
        </div>
      </div>
    </div>
    <div class="absolute bottom-4 text-center w-full">
      <button type="button" (click)="navigateWithFragment('dashboards')">
        <span class="material-symbols-outlined">keyboard_arrow_down</span>
      </button>
    </div>
  </section>
  <section class="snap-start h-screen text-slate-50 relative flex flex-col gap-4  p-16" id="dashboards">
    <div class="lg:text-3xl text-xl h-fit">
      <h1>Our Dashboards</h1>
    </div>
    <div class="grid gap-4 grid-cols-2 lg:grid-cols-3">
      @for (product of products; track product.id) {
      <div (click)="goToProduct(product.name)" class="card w-full flex flex-row    p-4 hover:cursor-pointer">
        <div class="flex justify-center items-center w-full basis-1/4">

          <span class="material-symbols-outlined text-[64px]!">{{
            product.material_icon
            }}</span>


        </div>
        <div class="basis-3/4 flex flex-col justify-center p-2.5">
          <h1>{{ product.name }}</h1>
          <p class="text-slate-400 text-xs xl:text-sm leading-4 tracking-tight">
            {{ product.shortDescription }}
          </p>
        </div>
      </div>
      }
    </div>
    <!-- <div class="absolute bottom-4 text-center w-full">
      <button type="button" (click)="navigateWithFragment('fifth')">
        <span class="material-symbols-outlined">keyboard_arrow_down</span>
      </button>
    </div> -->
  </section>

  <!-- <section
    class="snap-start h-screen text-slate-50 relative flex items-center justify-center"
    id="fifth"
  >
    <div class="text-white w-3/5 xl:w-1/3">
      <h1 class="text-2xl xl:text-4xl text-center p-4">Pricing</h1>
      <div class="bg-base-100/15 bg-opacity-10 rounded-sm -lg shadow-lg p-8">
        <div class="grid grid-cols-2 mt-8">
          <div class="col-start-1 flex items-center justify-center">
            <div>
              <h1 class="text-2xl xl:text-7xl">&euro; From 950 / month</h1>
              <p class="font-bold text-slate-300">
                Depending on included dashboards and services
              </p>
              <p
                class="text-xs ml-2 xlml-4 px-2 py-1 bg-base-100/15 bg-opacity-10 rounded-sm -lg w-fit"
              >
                Get in touch through the contact form for more information
              </p>
            </div>
          </div>
          <div class="col-start-2 leading-loose">
            <p class="text-sm font-bold">Blue Ocean platform features:</p>
            <ul class="leading-loose text-slate-300">
              <li>Cost, compliancy, infrastructure dashboards and more</li>
              <li>Central insight location</li>
              <li>Multi-tenant capabilities</li>
              <li>Flexible feature addition based on feedback</li>
            </ul>
          </div>
          <div
            class="flex col-start-1 col-span-2 mt-8 items-center justify-center"
          >
            <button
              type="button"
              [routerLink]="authenticated() ? '/home' : '/login'"
              class="px-2 py-1 w-2/5 bg-primary text-white font-thin rounded-sm -lg hover:cursor-pointer hover:bg-opacity-75"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  </section> -->
</main>